export function formatLatLon(value, dir) {
  const magnitude = Math.abs(value).toFixed(6);
  return dir ? `${magnitude}° ${dir}` : `${magnitude}°`;
}

export function formatAge(ms) {
  if (ms == null || ms < 0) return '--';

  const totalSeconds = Math.floor(ms / 1000);
  if (totalSeconds < 60) return `${totalSeconds}s`;

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes < 60) return `${minutes}m ${seconds}s`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ${minutes % 60}m`;

  const days = Math.floor(hours / 24);
  return `${days}d ${hours % 24}h`;
}

export function formatNumber(value, digits = 1) {
  return typeof value === 'number' && !Number.isNaN(value) ? value.toFixed(digits) : null;
}

// Always minutes + seconds, so a glance gives the same shape regardless of
// magnitude (formatAge above drops to bare seconds under a minute).
export function formatAgeMinSec(ms) {
  if (ms == null || ms < 0) return '--';

  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes}m ${String(seconds).padStart(2, '0')}s`;
}

const AGE_FRESH_MS = 60_000;
const AGE_STALE_MS = 180_000;
const FRESH_RGB = [76, 175, 80]; // #4caf50
const STALE_RGB = [229, 57, 53]; // #e53935

/**
 * Green while under a minute old, ramping to red by three minutes.
 * Interpolated rather than stepped so the colour itself reads as "how stale",
 * not just "stale or not".
 */
export function ageColor(ms) {
  if (ms == null) return 'rgba(232, 232, 232, 0.45)';
  if (ms <= AGE_FRESH_MS) return `rgb(${FRESH_RGB.join(', ')})`;
  if (ms >= AGE_STALE_MS) return `rgb(${STALE_RGB.join(', ')})`;

  const t = (ms - AGE_FRESH_MS) / (AGE_STALE_MS - AGE_FRESH_MS);
  const channels = FRESH_RGB.map((from, i) => Math.round(from + (STALE_RGB[i] - from) * t));

  return `rgb(${channels.join(', ')})`;
}
